import script from "./ListItemsWithTableLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListItemsWithTableLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ListItemsWithTableLayout.vue?vue&type=style&index=0&id=3ea2c7fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea2c7fc"]])

export default __exports__